import { cn } from '@/lib/utils'

interface RailFootnoteProps {
  children: string
  className?: string
}

/**
 * The line that closes the rail. Static copy, by design: it is the one block
 * with no endpoint behind it and no endpoint wanted.
 *
 * It is also the only part of the rail that varies by screen. The V2 renders
 * prove the rest does not — a sha256 of the rail crop
 * (x=1048..1408, y=124..1253) is byte-identical across Home, Market Overview,
 * Account and the collapsed-sidebar Home, and Portfolio, Screener and
 * Watchlist diverge only below y=1154, which is this line and the tail of the
 * card above it. Hence a prop rather than a per-screen component.
 */
export default function RailFootnote({ children, className }: RailFootnoteProps) {
  return <p className={cn('px-1 text-body-xs text-muted-foreground', className)}>{children}</p>
}
